import { createThunkEffect, createAction } from "../../utilities/ActionUtility";
import * as BasketEffect from "./BasketEffect";

export const REQUEST_BASKET = "BasketEffect.REQUEST_BASKET";
export const REQUEST_BASKET_FINISHED = "BasketEffect.REQUEST_BASKET_FINISHED";

export function requestBasket(user) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_BASKET, BasketEffect.requestBasket, user);
    };
}

const generateRandomId = () => {
    return Math.random().toString(36).substring(2);
};

export const ADD_ITEM_LOCALSTORAGE = "BasketEffect.ADD_ITEM_LOCALSTORAGE";
export const ADD_ITEM_LOCALSTORAGE_FINISHED = "BasketEffect.ADD_ITEM_LOCALSTORAGE_FINISHED";

export const ADD_ITEM = "BasketEffect.ADD_ITEM";
export const ADD_ITEM_FINISHED = "BasketEffect.ADD_ITEM_FINISHED";

export function addItem(user, orderItem, vat) {
    if (user) {
        return async (dispatch) => {
            await createThunkEffect(dispatch, ADD_ITEM, BasketEffect.addItem, user, orderItem);
        };
    } else {
        return async (dispatch) => {
            orderItem["id"] = generateRandomId();
            await createThunkEffect(dispatch, ADD_ITEM_LOCALSTORAGE, BasketEffect.addItemToLocalStorage, orderItem, vat);
        };
    }
}

export const DELETE_ITEM = "BasketEffect.DELETE_ITEM";
export const DELETE_ITEM_FINISHED = "BasketEffect.DELETE_ITEM_FINISHED";

export function deleteItem(user, itemId, vat) {
    if (user) {
        return async (dispatch) => {
            await createThunkEffect(dispatch, DELETE_ITEM, BasketEffect.deleteItem, user, itemId);
        };
    } else {
        return async (dispatch) => {
            await createThunkEffect(dispatch, DELETE_ITEM, BasketEffect.deleteItemFromLocalStorage, itemId, vat);
        };
    }
}

export const DELETE_ALL = "BasketEffect.DELETE_ALL";
export const DELETE_ALL_FINISHED = "BasketEffect.DELETE_ALL_FINISHED";

export function deleteAll(user) {
    if (user) {
        return async (dispatch) => {
            await createThunkEffect(dispatch, DELETE_ALL, BasketEffect.deleteAll, user);
        };
    } else {
        return async (dispatch) => {
            await createThunkEffect(dispatch, DELETE_ALL, BasketEffect.deleteAllFromLocalStorage);
        };
    }
}

export const CHECK_OUT = "BasketEffect.CHECK_OUT";
export const CHECK_OUT_FINISHED = "BasketEffect.CHECK_OUT_FINISHED";

export function checkOut(user, params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, CHECK_OUT, BasketEffect.checkOut, user, params);
    };
}

export const ADD_ITEMS_FROM_LS_TO_DB = "BasketEffect.ADD_ITEMS_FROM_LS_TO_DB";
export const ADD_ITEMS_FROM_LS_TO_DB_FINISHED = "BasketEffect.ADD_ITEMS_FROM_LS_TO_DB_FINISHED";

export function addItemsFromLocalStorageToDatabase(user) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, ADD_ITEMS_FROM_LS_TO_DB, BasketEffect.addItemsFromLocalStorageToDatabase, user);
    };

}

export const ADD_ADDITIONAL_INFO = "BasketEffect.ADD_ADDITIONAL_INFO";
export const ADD_ADDITIONAL_INFO_FINISHED = "BasketEffect.ADD_ADDITIONAL_INFO_FINISHED";

export function addAdditionalInfo(userId, params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, ADD_ADDITIONAL_INFO, BasketEffect.addAdditionalInfo, userId, params);
    };
}

export const DELETE_BACKEND_ACCEPTANCE_PAYMENT_FROM_STATE = "DELETE_BACKEND_ACCEPTANCE_PAYMENT_FROM_STATE";

export function deleteBackendAcceptancePayment() {
    return async(dispatch) => {
        await dispatch(createAction(DELETE_BACKEND_ACCEPTANCE_PAYMENT_FROM_STATE));
    };
}